export function startOfDay(date) {
  const day = new Date(date);
  day.setHours(0, 0, 0, 0);
  return day;
}

export function parseLocalDate(value) {
  if (!value) {
    return null;
  }
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) {
    return null;
  }
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
}

export function bookingStartDate(openingDate) {
  const today = startOfDay(new Date());
  const opening = openingDate instanceof Date ? startOfDay(openingDate) : parseLocalDate(openingDate);
  if (!opening || opening.getTime() <= today.getTime()) {
    return today;
  }
  return opening;
}

export function defaultStay(openingDate) {
  const from = bookingStartDate(openingDate);
  const to = new Date(from);
  to.setDate(to.getDate() + 1);
  return { from, to };
}

export function stayPayload(from, to) {
  const start = startOfDay(from);
  const end = startOfDay(to);
  return {
    frommonth: start.getMonth() + 1,
    fromday: start.getDate(),
    fromyear: start.getFullYear(),
    tomonth: end.getMonth() + 1,
    dayto: end.getDate(),
    toyear: end.getFullYear(),
    nbdays: (end - start) / (1000 * 60 * 60 * 24),
  };
}

export function openingDateForCurrentProperty() {
  if (typeof drupalSettings === 'undefined' || typeof drupalSettings.property_page === 'undefined') {
    return '';
  }
  let properties = [];
  try {
    const raw = drupalSettings.is_sabre
      ? drupalSettings.centara_sabre && drupalSettings.centara_sabre.booknow_property_data
      : drupalSettings.centara_fastbooking && drupalSettings.centara_fastbooking.booknow_property_data;
    properties = JSON.parse(raw || '[]');
  }
  catch (e) {
    return '';
  }
  if (!Array.isArray(properties)) {
    return '';
  }
  const pptyId = drupalSettings.property_page.ppty_id;
  const match = properties.find((item) => String(item.ppty_id) === String(pptyId));
  return match && match.opening_date ? match.opening_date : '';
}
